import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { envVars } from '../env/envValues';

export function oidcConfig(env: envVars): UserManagerSettings {
  return {
    authority: env.OIDC_AUTHORITY,
    client_id: env.OIDC_CLIENT_ID,
    redirect_uri: env.OIDC_REDIRECT_URI, 
    silent_redirect_uri: env.OIDC_SILENT_REDIRECT_URI,
    response_type: "code",
    scope: "openid offline_access",
    // automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  };
}
